import { Injectable } from '@angular/core';
import { Core2Config } from '../../shared/core2Config';
import { HttpClient } from '@angular/common/http';
import { WarrantyProductRegistrationAttachmentContainerModel } from '../../../../../../models/aggregates/erp/warranty';
import { ApiResponseModel, ApiVisa, BasicApiResponseModel } from '../../shared';
import { FilesDetailsRequest } from '../../../../../../models/file-image';
import { BaseApiPublicLoginTemplateService } from '../../shared/base-api-public-login-template.service';
import { Observable } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class WarrantyProductRegistrationAttachmentService extends BaseApiPublicLoginTemplateService<WarrantyProductRegistrationAttachmentContainerModel, WarrantyProductRegistrationAttachmentContainerModel, WarrantyProductRegistrationAttachmentContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.WARRANTY_PREFIX + 'product-registration-attachments' + Core2Config.BACKOFFICE_EP_SUFFIX;

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.WARRANTY_PREFIX + 'product-registration-attachments/' + Core2Config.BACKOFFICE_EP_SUFFIX;
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.WARRANTY_PREFIX + 'product-registration-attachments/' + Core2Config.BACKOFFICE_EP_SUFFIX;
    this.endpoint_path_login_url = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.WARRANTY_PREFIX + 'product-registration-attachments/' + 'add-files/' + Core2Config.LOGIN_EP_SUFFIX;
    this.endpoint_path_login_entity_url = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.WARRANTY_PREFIX + 'product-registration-attachments/' + Core2Config.LOGIN_ENTITY_EP_SUFFIX;
    this.httpClient = http;
  }

  
  addAttachmentsAndDetailsLoginEp(hdrGuid: string, files: File[], visa: ApiVisa, filesDetails?: FilesDetailsRequest) {
    if (this.endpoint_path_login_url && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path_login_url;
    }

    const formData: FormData = new FormData();

    files.forEach(file => formData.append('files', file));
    if (filesDetails) {
      formData.set(
        'files-data',
        new Blob([JSON.stringify(filesDetails)], { type: 'application/json' }),
        'files-data.json')
    }

    return this.httpClient.put<ApiResponseModel<WarrantyProductRegistrationAttachmentContainerModel>>(
      this.apiUrl + '/' + hdrGuid,
      formData,
      this.getHttpHeader(visa)
    );
  }

  addAttachmentsAndDetailsLoginEntity(hdrGuid: string, files: File[], visa: ApiVisa, filesDetails?: FilesDetailsRequest) {
    if (visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.WARRANTY_PREFIX + 'product-registration-attachments/' + 'add-files/' + Core2Config.LOGIN_ENTITY_EP_SUFFIX;
    }

    const formData: FormData = new FormData();

    files.forEach(file => formData.append('files', file));
    if (filesDetails) {
      formData.set(
        'files-data',
        new Blob([JSON.stringify(filesDetails)], { type: 'application/json' }),
        'files-data.json')
    }

    return this.httpClient.put<ApiResponseModel<WarrantyProductRegistrationAttachmentContainerModel>>(
      this.apiUrl + '/' + hdrGuid,
      formData,
      this.getHttpHeader(visa)
    );
  }

  replaceAttachmentFileLoginEntity(guid: string, file: File, visa: ApiVisa): Observable<BasicApiResponseModel<WarrantyProductRegistrationAttachmentContainerModel>>{
    const loginEntityApiUrl = visa.api_domain_url ?
    visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.WARRANTY_PREFIX + 'product-registration-attachments/' + 'replace-file/' + Core2Config.LOGIN_ENTITY_EP_SUFFIX
    : Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.WARRANTY_PREFIX + 'product-registration-attachments/' + 'replace-file/' + Core2Config.LOGIN_ENTITY_EP_SUFFIX;
    const apiUrl =  loginEntityApiUrl + '/' + guid;

    const formData: FormData = new FormData();
    formData.append('file', file)

    return this.httpClient.put<BasicApiResponseModel<WarrantyProductRegistrationAttachmentContainerModel>>(
      apiUrl,
      formData,
      this.getHttpHeader(visa)
    );
  }

  getAttachmentFile(guid: string, apiVisa: ApiVisa): Observable<Blob> {
    let url;
    if (this.endpoint_path && apiVisa.api_domain_url) {
      this.apiUrl = apiVisa.api_domain_url + this.endpoint_path;
      url = apiVisa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.WARRANTY_PREFIX + 'product-registration-attachments/file/backoffice-ep/' + guid;
    }
    return this.httpClient.get<Blob>(
      url ,
      this.getHttpHeaderBlob(apiVisa)
    );
  }
}
